export default __webpack_public_path__ + "static/media/about-loggi-facil.9224f73e.png";